import styles from "./stars-picker.module.scss";

export const StarsPicker = (props: {
    customKey: number,
    onScoreChange: (score: number) => void
}) => {

    return (
        <div className={styles["rate"]}>
            {
                [5, 4, 3, 2, 1].map(nb =>
                    <>
                        <input
                            type="radio"
                            id={props.customKey + "star" + nb}
                            name={props.customKey + "rate"}
                            value={nb}
                            onClick={() => props.onScoreChange(nb)}
                        />
                        <label
                            htmlFor={props.customKey + "star" + nb}
                            title="text">
                            {nb} stars
                        </label>
                    </>
                )
            }
        </div>
    )
}
